import React from 'react'

import { COLORS, styled } from '../../theme'
import { computeStatusPropsFromOptionItem, E2eTag } from '../../utils'
import { Status } from '../Status'

const StatusWrapper = styled('div')`
  display: flex;
`

const Separator = styled('span')`
  color: ${COLORS.text.primary};
  ::before {
    content: ', ';
  }
`

type OptionItemProps = {
  label: string
  icon?: string
  color?: string
  withSeparator?: boolean
  className?: string
} & E2eTag

export const OptionItemValue = ({ label, icon, color, withSeparator, className }: OptionItemProps) => {
  const statusProps = computeStatusPropsFromOptionItem({ fontColor: color, icon })

  return (
    <StatusWrapper className={className}>
      <Status {...statusProps}>
        {label}
        {withSeparator && <Separator />}
      </Status>
    </StatusWrapper>
  )
}
